import domready from "domready"
import raf from "raf"
import SimplexNoise from "simplex-noise"
// noinspection ES6UnusedImports
import STYLE from "./style.css"
import Vector from "./vector";
import Color from "./Color";
import { TAU } from "./util";


const MAX_VELOCITY = 15;

const config = {
    width: 0,
    height: 0
};

let ctx, canvas;

const noise = new SimplexNoise();

function Ball(pos, velocity, color)
{
    this.pos = pos;
    this.velocity = velocity;
    this.color = color;
}

const NOISE_SCALE = 0.005;

const balls = [];

const BLACK = Color.from("#000008");

function init()
{
    canvas = document.getElementById("screen");
    ctx = canvas.getContext("2d");

    const width = (window.innerWidth) | 0;
    const height = (window.innerHeight) | 0;

    config.width = width;
    config.height = height;

    canvas.width = width;
    canvas.height = height;

    ctx.fillStyle = BLACK.toRGB();
    ctx.fillRect(0, 0, width, height);

    for (var i = 0; i < 100; i++)
    {
        balls.push(
            new Ball(
                new Vector(width / 2, height / 2),
                Vector.randomDirection(MAX_VELOCITY),
                Color.from("#fff")
            )
        )
    }
}


const vGravity = new Vector(0, 0.01);


function main()
{
    const {width, height} = config;

    for (let i = 0; i < balls.length; i++)
    {
        const {pos, velocity, color} = balls[i];

        //velocity.add(vGravity);

        if (velocity.length() > MAX_VELOCITY)
        {
            velocity.norm(MAX_VELOCITY);
        }

        const n = (1 + noise.noise2D(pos.x * NOISE_SCALE, pos.y * NOISE_SCALE))/2;
        ctx.lineWidth = 1 + n * 2;
        ctx.strokeStyle = color.mix(BLACK, 0.2 + n * 0.8).toRGB();
        ctx.beginPath();
        ctx.moveTo(pos.x, pos.y - n * 140);
        pos.add(velocity);


        let bumped = false;
        if (pos.x < 0 || pos.x >= width)
        {
            velocity.x = -velocity.x;
            bumped = true;
        }

        if (pos.y < 0 || pos.y >= height)
        {
            velocity.y = -velocity.y;
            bumped = true;
        }

        if (bumped)
        {
            balls[i].color = Color.fromHSL(
                Math.atan2( height/2 - pos.y, width/2 - pos.x) / TAU,
                0.7,
                0.5
            ).mix(color, 0.5);
        }
        const n2 = (1 + noise.noise2D(pos.x * NOISE_SCALE, pos.y * NOISE_SCALE))/2;

        ctx.lineTo(pos.x, pos.y - n2 * 140);
        ctx.stroke();

    }

    raf(main);
}


domready(
    () => {

        init();

        raf(main);

    }
);
